// GraphQL mutations for chat
import {
  CHAT_ROOM_FIELDS_FRAGMENT,
  CHAT_ROOM_INIT_FRAGMENT,
  MESSAGE_MUTATION_RESPONSE_FRAGMENT
} from '../fragments/chat';

// Initialize or get existing chat room
// Note: This mutation returns customer and shop as string IDs, not nested objects
export const INITIALIZE_OR_GET_CHAT_ROOM_MUTATION = `
  mutation InitializeOrGetChatRoom($userId: String!, $shopId: String!) {
    initializeOrGetChatRoom(userId: $userId, shopId: $shopId) {
      ${CHAT_ROOM_INIT_FRAGMENT}
    }
  }
`;

// Send a message
export const SEND_MESSAGE_MUTATION = `
  mutation SendMessage($chatRoomId: String!, $content: String!, $attachmentIds: [String], $socketId: String) {
    sendMessage(chatRoomId: $chatRoomId, content: $content, attachmentIds: $attachmentIds, socketId: $socketId) {
      ${MESSAGE_MUTATION_RESPONSE_FRAGMENT}
    }
  }
`;

// Mark messages as read
export const MARK_AS_READ_MUTATION = `
  mutation MarkAsRead($roomId: String!) {
    markAsRead(roomId: $roomId) {
      success
      message
    }
  }
`;